<template>
    <ClientOnly>
        <div class="form-demo">
            <h2 class="text-center fw-bold mb-32">Se connecter</h2>
            <button @click="dashStore.signInWithGoogle" class="btn btn-medium google-btn w-100">
                <span> 
                    <svg id="chercher" xmlns="http://www.w3.org/2000/svg" width="21.297" height="21.298" viewBox="0 0 21.297 21.298">
                      <path id="Tracé_191" data-name="Tracé 191" d="M4.72,145.387l-.741,2.768-2.71.057a10.667,10.667,0,0,1-.078-9.944h0l2.412.442,1.057,2.4a6.355,6.355,0,0,0,.06,4.279Z" transform="translate(0 -132.517)" fill="#fbbb00"/>
                      <path id="Tracé_192" data-name="Tracé 192" d="M271.857,208.176a10.645,10.645,0,0,1-3.8,10.294h0l-3.038-.155-.43-2.684a6.346,6.346,0,0,0,2.731-3.241h-5.694v-4.213h10.229Z" transform="translate(-250.745 -199.517)" fill="#518ef8"/>
                      <path id="Tracé_193" data-name="Tracé 193" d="M46.555,315.491h0a10.652,10.652,0,0,1-16.046-3.258l3.451-2.825a6.333,6.333,0,0,0,9.126,3.243Z" transform="translate(-29.24 -296.539)" fill="#28b446"/>
                      <path id="Tracé_194" data-name="Tracé 194" d="M44.879,2.452l-3.45,2.824a6.332,6.332,0,0,0-9.336,3.316l-3.469-2.84h0a10.651,10.651,0,0,1,16.255-3.3Z" transform="translate(-27.433)" fill="#f14336"/>
                    </svg>
                    
                  </span>
                Se connecter avec Google
            </button>
            <Divider align="center" type="solid">
                <span class="text-gray-600 fsz-12">ou</span>
            </Divider>
            <form @submit.prevent="handleSubmit(!v$.$invalid)" class="p-fluid d-flex flex-column gap-3">
                <div class="field">
                    <div class="simple-input">
                        <label for="email" class="not-floated"
                            :class="{ 'p-error': v$.email.$invalid && submitted }">Adresse e-mail</label>
                        <InputText id="email" v-model="v$.email.$model"
                            :class="{ 'p-invalid': v$.email.$invalid && submitted }" aria-describedby="email-error" />
                    </div>
                    <span v-if="v$.email.$error && submitted">
                        <span id="email-error" v-for="(_, index) of v$.email.$errors" :key="index">
                            <small class="p-error">Ce champs est obligatoire.</small>
                        </span>
                    </span>
                    <small v-else-if="
                        (v$.email.$invalid && submitted)" class="p-error">Saisissez votre adresse e-mail</small>
                </div>
                <div class="field">
                    <div class="simple-input">
                        <div class="d-flex justify-content-between align-items-center">
                            <label for="password" class="not-floated"
                                :class="{ 'p-error': v$.password.$invalid && submitted }">Mot de passe</label>
                            <nuxt-link to="/authentication/forgot-password" class="simple-link text-primary-400 fsz-12">Mot de passe oublié?</nuxt-link>
                        </div>
                        <Password id="password" v-model="v$.password.$model" :feedback="false"
                            :class="{ 'p-invalid': v$.password.$invalid && submitted }" toggleMask>
                        </Password>
                    </div>
                    <small v-if="
                        (v$.password.$invalid && submitted)" class="p-error">Ce champs est obligatoire.</small>
                </div>
                <p v-if="conxionResult" class="bg-danger-50 border-color-danger-600 text-danger-600 p-3 rounded-2 border fsz-14">
                    {{errorMsg}}
                </p>
                <p v-if="dashStore.emailExist" class="bg-danger-50 border-color-danger-600 text-danger-600 p-3 rounded-2 border fsz-12">
                    Un compte avec cette adresse e-mail existe déjà. Veuillez vous connecter en utilisant votre e-mail et mot de passe.
                </p>
                <button type="submit" class="btn btn-solid-primary-600 w-100 disabled-pointer" :disabled="pending || !isRecaptchaVerified">
                    <div v-if="pending" class="spinner-border text-white-600" role="status">
                    </div>
                    Se connecter
                </button>

                <RecaptchaV2Recaptcha
                    v-if="showRecaptcha"
                    @recaptcha-verified="(e: boolean) => isRecaptchaVerified = e"
                    @update-reset-function="(e: boolean) => fetchSpinnerResult = e"
                    @update-failed-attempt="(e: number) => failedAttempts = e"
                    :reset-state="fetchSpinnerResult"
                />

                <p class="py-3 fsz-12 text-gray-900 text-center">
                    Vous n’avez pas de compte ?
                    <nuxt-link class="simple-link text-primary-400" to="/authentication/signup">Créer un compte</nuxt-link>
                </p>

            </form>
        </div>
        <div v-if="dashStore.pendingAuth" class="spinner-overlay">
            <div class="spinner-box">
                <div class="spinner-border text-primary" role="status"></div>
                <p class="spinner-text">Connexion en cours...</p>
            </div>  
        </div>
    </ClientOnly>
</template>

<script setup lang="ts">
import { email, required } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";

const runTimeConfig = useRuntimeConfig();
const route = useRoute();
const cookie = useCookie("userToken" , { maxAge : 5184000 });
const cookieId = useCookie("userId" , { maxAge : 5184000 });
const cookieUserEmail = useCookie('userMail');
const dashStore = useDashboardStore();

const conxionResult = ref(false);
const errorMsg = ref('');
const state = reactive({
    email: "",
    password: "",
});
const pending = ref(false)

const rules = {
    email: { required, email },
    password: { required },
};
const submitted = ref(false);
const showRecaptcha = ref(false);
const failedAttempts = ref(0);
const firstShowRecaptcha = ref(false);
const isRecaptchaVerified = ref(true);
const fetchSpinnerResult = ref(false);

const v$ = useVuelidate(rules, state);

const isTruthyQueryValue = (value: unknown): boolean => {
    if (Array.isArray(value)) {
        return isTruthyQueryValue(value[0]);
    }

    if (typeof value !== "string") {
        return false;
    }

    const normalized = value.trim().toLowerCase();
    return normalized === "1" || normalized === "true" || normalized === "yes";
};

const redirectToTopautoApp = (token: string): void => {
    window.location.replace(`topauto://callback?token=${encodeURIComponent(token)}`);
};

onMounted(() => {
    dashStore.emailExist = false;
});

const handleSubmit = async (isFormValid : any) => {
    submitted.value = true;

    if (!isFormValid) {
        return;
    }
    execute()
    
};

    const { execute } = await useFetch(() => "/users/sign-in", {
        immediate : false,
        server: false,
        onRequest({ options }) {
    // Set the request headers
    options.method = 'POST'
    options.body =  {
    email: state.email,
    password: state.password,
    }
    options.baseURL = runTimeConfig.public.baseUrl
    // console.log(request);
    pending.value = true
  },
  onRequestError() {
    // Handle the request errors
    pending.value = false
  },
  onResponse({ response }) {

    validationTest(response._data)
    

  },
  onResponseError({ response }) {
    // Handle the response errors
    pending.value = false
    if (response._data.error_message.includes("Error in signIn | Account not activated")) {
        cookieUserEmail.value = state.email;
        navigateTo('/authentication/verification')
    }
    // console.log( 'Handle the response errors response' , response);
    if (response._data.error_message.includes('Invalid credentials')) {
        conxionResult.value = !response._data.success
        errorMsg.value = 'E-mail ou mot de passe incorrect.'
        // console.log(conxionResult.value , errorMsg.value );
        failedAttempts.value += 1;
        if (failedAttempts.value >= 5 && !firstShowRecaptcha.value) {
            showRecaptcha.value = true;
            isRecaptchaVerified.value = false;
            firstShowRecaptcha.value = true;
            trackRecaptchaShown();
            return;
        }
        if (firstShowRecaptcha.value) {
            isRecaptchaVerified.value = false;
            fetchSpinnerResult.value = true;
        }
    }
  },
});


const validationTest = async (data : any) => {
    
    pending.value = true;
    const token = String(data.accessToken ?? "");
    const userId = String(data.user?.id ?? "");
    cookie.value = token;
    cookieId.value = userId;

    if(data.user.activated){
        conxionResult.value = false
        errorMsg.value = ''
        if (isTruthyQueryValue(route.query.mobileAuth)) {
            redirectToTopautoApp(token);
            return;
        }
        return navigateTo('/dashboard/home')
    }


    return navigateTo('/authentication/verification')

};


</script>

<style lang="scss" scoped>

</style>
